import './vendor';

import helpers from './helpers';

import {vhFix} from './vendor/vh-fix';
import lazyLoading from './modules/lazyLoading';

import {loadSite} from './components/load-site';
import {menuInit} from './components/menu';
import {sliderInit} from './components/slider';
import {socialInit} from './components/social';

import {homeInit} from './pages/home';

let resizeTimeout = null;

vhFix();

loadSite().then(() => {
	helpers.update();
	lazyLoading.init();

	objectFitImages();
	menuInit();
	sliderInit();
	socialInit();
	homeInit();
});

window.addEventListener('resize', () => {
	clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(() => {
		ScrollTrigger.refresh();
	}, 500);
});
